import { apiClient } from './api/client';

const apiPrefix = process.env.VUE_APP_API_PREFIX;

export interface SubscriptionEntitlement {
  expiresAt: string | null;
  entitlementId?: string;
}

export interface SubscriptionStatus {
  subscribed: boolean;
  entitlements: Record<string, SubscriptionEntitlement>;
  updatedAt: string | null;
}

export class UserService {
  static async uploadProfilePhoto(formData: FormData): Promise<{ photoUrl?: string }> {
    const resp = await apiClient.axios.post(`/users/upload_photo`, formData);
    return resp.data || {};
  }

  static async getProfilePhoto(userId: string): Promise<string | null> {
    const resp = await apiClient.axios.get(`/users/${userId}/get_photo`);
    return resp.data?.photoUrl || null;
  }

  /**
   * Get the current user's subscription/entitlement status.
   * Endpoint: GET /users/subscription_status
   */
  static async getSubscriptionStatus(): Promise<SubscriptionStatus> {
    const resp = await apiClient.axios.get(`/users/subscription_status`);
    return {
      subscribed: !!resp.data?.subscribed,
      entitlements: resp.data?.entitlements || {},
      updatedAt: resp.data?.updatedAt ?? null
    };
  }
}


